import {fxxl_config_from_php} from '@fxxl/globals';

/**
 * Die Klasse "FxxlConfigs" stellt eine statische Methode "getConfig" bereit, die
 * ein Objekt mit verschiedenen Konfigurationen zurückgibt.
 */
export default class FxxlConfigs {
      constructor() {
    }

    static getConfig() {
          return {
              storageKeys: {
                  firstAction: 'fxxlStorageFirstAction',
                  utmSourceNewsletter: 'fxxlStorageUtmSourceNewsletter',
                  newsletterPopup: 'fxxlStorageNewsletterPopup',
                  shopSuggestion: 'fxxlStorageShopSuggestion',
                  pageSessionWertgarantieDeviceInsurancesPraefix: 'wg_insurance_premium_',
                  pageSessionWertgarantieViewedBikelockPopup: 'fxxl_wertgarantie_slider_first_view',
                  cmt: 'fxxlStorageCMT',
                  branchId: 'fxxlBranchId',
                  branchOrt: 'fxxlBranchOrt',
                  branchParam: 'fxxlBranchParam',
                  branchSource: 'fxxlBranchSource',
                  branchDistance: 'fxxlBranchDistance',
              },
              cookieNames: {
                  leasingCalculatorData: 'fxxlLeasingCalculatorData'
              },
              eventNames: {
                  firstAction: 'fxxl-first-action',
                  firstActionCached: 'fxxl-first-action-cached',
                  formValidation: 'fxxl-form-validation',
                  leasingAutomationRequestCancel: 'fxxl-leasingautomation-request-cancel',
                  leasingAutomationRequestSubmit: 'fxxl-leasingautomation-request-submit',
                  narrowerHasChanged: 'fxxl-narrower-has-changed',
                  narrowerRequestSubmit: 'fxxl-narrower-request-submit',
                  narrowerRequestUpdate: 'fxxl-narrower-request-update',
                  ready: 'fxxl-ready',
                  warenkorbHasChanged: 'fxxl-warenkorb-has-changed',
                  personalDataLoaded: 'fxxl-personal-data-is-saved',
                  searchPreviewLoaded: 'fxxl-search-preview-loaded',
                  warenkorbAddedLinexoInsurance: 'fxxl-warenkorb-added-linexo-insurance',
                  jsonModalOpened: 'fxxl-json-modal-opened',
              },
              server: fxxl_config_from_php,
          };
    }
}
